import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const DropdownChevronDownGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('#696D70', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <g>
        <path
          d="M12 7.16656L11.06 6.22656L8 9.2799L4.94 6.22656L4 7.16656L8 11.1666L12 7.16656Z"
          fill={fillColor}
        />
      </g>
    </g>
  );
};

export const DropdownChevronDownSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <DropdownChevronDownGroup {...props} />
    </svg>
  );
};
